import { render, staticRenderFns } from "./Percent.vue?vue&type=template&id=24921f56&scoped=true&"
import script from "./Percent.vue?vue&type=script&lang=js&"
export * from "./Percent.vue?vue&type=script&lang=js&"
import style0 from "./Percent.vue?vue&type=style&index=0&id=24921f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24921f56",
  null
  
)

export default component.exports